import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Router, RouteComponentProps } from "@reach/router";
import { PowerSingleSelectPositionMenu } from '../positions-menu/PowerSingleSelectPositionsMenu';
import { FlexibleSubMenu } from '../menu/subMenu';
import { Power } from './power/Power';
import { RawAudioConinuous } from './raw-audio-continuous/RawAudioContinuous'
import { WeeklyRestart } from './weekly-restart/WeeklyRestart'
import { QuietPeriods } from './quiet-periods/QuietPeriods'
import { Capabilities } from './capabilities/Capabilities'
import { isJsonEqual } from '../../lib/typeCheck';
import { selectUser } from '../../store/users/userSlice';

// Store
import { getSelectedNodes } from '../../store/positions/menuNodesSlice'

const LeftContainer = styled.div<RouteComponentProps>`
  margin-left: 0px;
  width: 20%;
  height: 100%;
  background: #FFF;
  border-right: 1px solid #AAA;
  overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MiddleContainer = styled.div<RouteComponentProps>`
  width: 80%;
  height: 100%;
  background: #FFF;
  position: relative;
`;

const RightContainer = styled.div`
  width: 20%;
  height: 100%;
  background: #FFF;
`;

const StyledRouter = styled(Router)`
  height: 100%;
  width: 100%;
`;

const StyledSingleDevices = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const SingleDevices = ({ path }: { path: string; }) => {

  const menuNodePosition = useSelector(getSelectedNodes, isJsonEqual);    
  const dispatch = useDispatch();
  const user = useSelector(selectUser, isJsonEqual); 
  
  const features = [
    {
      path: './',
      name: 'Power'
    },
    {
      path: 'rawaudio',
      name: 'NX-42WR Audio'
    },
    {
      path: 'weeklyrestart',
      name: 'Weekly Restart'          
    },
    {
      path: 'quietperiods',
      name: 'Do Not Disturb'
    },    
    {
      path: 'capabilities',
      name: 'Capabilities'
    }
  ];
  
  const show = true;
  
  useEffect(() => {
    // dispatch(initSingleNode())
  }, [user])
  
  return (
    <StyledSingleDevices>
      <LeftContainer path='*'>
        <PowerSingleSelectPositionMenu/>
      </LeftContainer>
      <MiddleContainer path='*'>
        {show? <FlexibleSubMenu features={features} nodes={menuNodePosition} /> : null}
        
        <StyledRouter>
          <Power path='/'/>
          <RawAudioConinuous path='/rawaudio'/>
          <WeeklyRestart path='/weeklyrestart'/>
          <QuietPeriods path='/quietperiods'/>
          <Capabilities path='/capabilities'/>
        </StyledRouter>             

      </MiddleContainer>
    </StyledSingleDevices>
  )
}

